import Joi from 'joi';

export const clinicValidator = (payload: unknown) => {
  const obj = Joi.object()
    .keys({
      name: Joi.string().required(),
      hospital_provider_number: Joi.string().required(),
      hpio: Joi.string().required(),
      email: Joi.string()
        .email({ maxDomainSegments: 2, tlds: { allow: false } })
        .required()
        .pattern(
          new RegExp('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$'),
        ),
      phone: Joi.string().length(10).required(),
      sms: Joi.string().allow(null).allow(''),
      address: Joi.string().required(),
      city: Joi.string().required(),
      state: Joi.string().required(),
      zipcode: Joi.string().required(),
    })
    .required();

  const { error } = obj.validate(payload);

  return error ? error.details : false;
};
